import React from "react";

const SUBSCRIBE_URL = "https://the-wealthy-miner.mn.co/";

const DetailsSection: React.FC = () => {
  return (
    <section className="bg-white pb-10 md:pb-12">
      <div className="w-full max-w-[1200px] mx-auto lg:px-6">
        <article className="w-full lg:w-[83.17%] mx-auto lg:rounded-b-[16px] rounded-none bg-[#EDF1F9] p-5 md:pt-10 md:pb-10 md:px-24 text-[#1f2d3d] font-[500] text-[17px] md:text-[14px] leading-[1.6]">
          {/* Intro block: text left, Rob avatar right - smaller/medium grey */}
          <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 mb-8">
            <p className="flex-1 order-2 md:order-1">
              At <strong>The Wealthy Miner</strong>, led by seasoned mining
              analyst and investor <strong>Rob Bruggeman</strong>, we specialize
              in uncovering undervalued junior mining opportunities with
              explosive potential—especially in gold, copper, and porphyry plays
              in top jurisdictions. Rob&apos;s deep dives, timely
              recommendations, and video analyses give subscribers the edge to
              capitalize on catalysts before the market wakes up.
            </p>
            <div className="flex justify-center md:justify-end shrink-0 order-1 md:order-2">
              <img
                src="/images/RobertBruggeman.webp"
                alt="Rob Bruggeman"
                className="rounded-full object-cover object-[center_18%] bg-[#0B6054]"
                style={{ width: "194.76px", height: "204px" }}
              />
            </div>
          </div>
          <hr className="my-5 border-0 h-[3px] bg-[#FFFF]" />

          {/* Real Results - dark text on content background */}
          <h2 className="text-[22px] md:text-[24px] font-[400] text-[#1f2d3d] mb-3 leading-[110%]">
            Real Results:{" "}
            <strong>
              Subscribers Who Followed Rob's August 2025 Pick on Kingfisher
              Metals Have Seen Gains of Over 200%
            </strong>{" "}
          </h2>

          <p>
            In August 2025, Rob recommended{" "}
            <strong>Kingfisher Metals (TSXV: KFR)</strong> as a high-conviction
            exploration play in British Columbia's prolific Golden Triangle.
            Subscribers had the chance to pick up shares between{" "}
            <strong>20 and 30 cents CAD</strong>, positioning them for
            substantial upside as the company's drill program unfolded.{" "}
          </p>

          <p className="mt-3">
            In his initial analysis, titled{" "}
            <em>
              &quot;Kingfisher Metals – Fishing for a Porphyry in the Golden
              Triangle&quot;
            </em>
            , Rob broke down the opportunity:
          </p>
          <ul className="list-disc pl-10 mt-3">
            <li>
              A <strong>$37 million exploreco </strong>(at the time) with a
              massive <strong>849 km² land position</strong> in the Golden
              Triangle, featuring multiple porphyry targets on the Highway 37
              project.{" "}
            </li>
            <li>
              Potential for a major discovery: If they hit a strong porphyry, it
              could value the company at{" "}
              <strong>$250–$500 million or more</strong>, offering{" "}
              <strong>10-bagger potential</strong>.{" "}
            </li>
            <li>
              <strong>Strong team:</strong> Led by geo Dustin Perry, with
              advisors like Golden Triangle expert Charlie Grieg, board member
              Ashwath Mehra, and backers including Alex Gubbins and Larry
              Childress. Reasonable CEO compensation ($180K) and a focus on
              exploration over promotion—most funds go straight into the
              ground.{" "}
            </li>
            <li>
              <strong>Drill program catalyst:</strong> A 7,500-meter program
              targeting the Williams and Hank zones, with early visual results
              showing broad potassic alteration (e.g., 478 meters in hole
              HW-25-004). Assays expected in early September 2025 could confirm
              or expand historic intercepts like 347 meters of 0.33% copper and
              0.39 g/t gold.{" "}
            </li>
            <li>
              <strong>Upside and risks:</strong> Rob noted the project's appeal
              to majors for acquisition, but cautioned on drilling costs
              (~$750/meter) and potential dilution. He advised waiting for
              assays but highlighted accumulation below $0.35 if the stock
              dipped, emphasizing the asymmetric reward if results
              impressed.{" "}
            </li>
          </ul>

          <p className="mt-4">
            Rob shared this via a detailed write-up and video, equipping
            subscribers with the full thesis to make informed decisions.{" "}
          </p>
          <p className="mt-4">
            <strong>Fast-forward to February 3, 2026:</strong>{" "}
          </p>
          <p className="mt-4">
            The drill results delivered, confirming strong porphyry
            mineralization and sparking a major re-rating. Shares that
            subscribers snagged at 20–30 cents have rocketed to a recent high of
            <strong> 90 cents CAD</strong>—and are currently trading at <strong>82 cents CAD</strong> amid
            continued momentum and positive market sentiment.
          </p>
          <p className="mt-4">
          That's a <strong>gain of over 200% </strong>(tripling or more) in under six months, driven by successful assays, resource expansions, and growing interest from majors in the Golden Triangle's copper-gold potential. This win underscores Rob's knack for spotting stories with real catalysts and takeover appeal in a bull market for metals.
          </p>

          <hr className="my-5 border-0 h-[3px] bg-[#FFFF]" />

          <h3 className="text-[25px] md:text-[30px] font-[800] leading-[30px] text-[#1f2d3d] mb-5 lg:text-left text-center">
            Why Join The Wealthy Miner Today?
          </h3>
          <ul className="list-disc pl-10 mt-2 space-y-2 mb-5">
            <li>
              <strong>Early Access to Rob&apos;s Picks:</strong> Get in before the crowd on opportunities like Kingfisher—complete with detailed reasoning and entry strategies.
            </li>
            <li>
              <strong>Expert Analysis + Videos:</strong> Rob's signature breakdowns, charts, and videos make complex mining stories easy to grasp and act on.
            </li>
            <li>
              <strong>Proven Track Record:</strong> Successes like this (and our recent Gold X2 double) prove the power of Rob's expertise in navigating junior volatility for outsized returns.
            </li>
            <li>
              <strong>Ongoing Insights:</strong>  Portfolio updates, market commentary, and catalyst alerts to keep you ahead in gold, silver, and critical metals.
            </li>
          </ul>
          <p className="mb-3">
          With metals prices soaring and juniors heating up, the next big winner could be just around the corner. Subscribe to harness Rob's insights and build your own wealthy mining portfolio.
          </p>
          <p className="mb-5">
            <strong>Subscribe Now to The Wealthy Miner</strong> and unlock premium access to
            Rob&apos;s recommendations, videos, and more.
          </p>

          {/* CTA - dark green button */}
          <a
            href={SUBSCRIBE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full rounded-md bg-[#0B6054] hover:bg-[#0a5349] text-white font-[700] text-[22px] md:text-[30px] leading-none py-3 md:py-4 transition-colors text-center"
          >
            Subscribe Today - Start Winning with Rob
          </a>
          <p className="text-[15px] px-5 text-[#1A2A44] font-[400] mt-2 text-center">
          Questions? Reach out or visit our FAQ. Past performance isn't a guarantee of future results.
          Junior mining investments carry high risk—always conduct your own research.
          </p>

          {/* Single card: social post mockup with embedded map image */}
          <div className="mt-6 bg-white rounded-[5px] shadow-[0px_4px_4px_0px_#00000040] p-6 overflow-hidden">
              <img
                src="/images/kingfisher.webp"
                alt="Kingfisher Metals"
                className="w-full h-auto rounded-sm"
              />
            </div>
           
        </article>
      </div>
    </section>
  );
};

export default DetailsSection;
